import { Mail, MapPin, ScanLine } from "lucide-react";

// Bottom-of-page support strip (3 contact options). Pure presentational.
const CONTACTS = [
    { i: Mail, t: "orders@toothrocket.com", d: "Email a case directly" },
    { i: MapPin, t: "Al Shafi St · New Al Rayyan, Doha", d: "Drop-off impressions in person" },
    { i: ScanLine, t: "Cloud transfer", d: "3Shape Communicate · Medit Link" },
];

export function WorkflowSupportStrip() {
    return (
        <section data-testid="workflow-support-strip" className="max-w-[1280px] mx-auto px-5 lg:px-8 py-20 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CONTACTS.map((c) => {
                const Icon = c.i;
                return (
                    <div key={c.t} className="tr-card p-6 flex items-start gap-4">
                        <div className="h-10 w-10 rounded-lg bg-slate-100 flex items-center justify-center text-slate-700 shrink-0">
                            <Icon size={18} />
                        </div>
                        <div>
                            <div className="font-display text-lg tracking-tight text-slate-900">{c.t}</div>
                            <div className="text-[13.5px] text-slate-600 mt-0.5">{c.d}</div>
                        </div>
                    </div>
                );
            })}
        </section>
    );
}
